import ReactPaginate from 'react-paginate';
import styles from './Pagination.module.css';
import { ArrowIcon } from '../../shared/icons/Arrow.jsx';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

export const Pagination = ({
  count,
  defaultPage,
  isVisible = true,
  itemsPerPage = 8,
  onChange,
  noRequest,
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has('page')) {
      const currentPage = Number(searchParams.get('page'));
      setCurrentPage(currentPage);
      !noRequest && onChange(currentPage - 1);
    } else {
      defaultPage ? setCurrentPage(defaultPage) : setCurrentPage(1);
      !noRequest && onChange(0);
    }
  }, []);

  const handleChange = (page) => {
    setSearchParams({
      page: page + 1,
    });
    setCurrentPage((prev) => page + 1);
    onChange(page);
  };

  return (
    <ReactPaginate
      pageCount={Math.ceil(count / itemsPerPage)}
      className={!isVisible ? 'd-none' : ''}
      pageClassName={`${styles.container} page-item`}
      pageLinkClassName={`${styles.sideButton} page-link`}
      previousClassName={`${styles.sideButton} page-link`}
      activeLinkClassName={styles.activePage}
      previousLabel={<ArrowIcon style={{ marginTop: '-3px', scale: '0.8' }} />}
      nextLabel={
        <ArrowIcon style={{ marginTop: '-3px', scale: '0.8', transform: 'rotate(180deg)' }} />
      }
      nextClassName={`${styles.sideButton} page-link`}
      onPageChange={(e) => handleChange(e.selected)}
      containerClassName={`pagination justify-content-end`}
      forcePage={currentPage - 1}
    />
  );
};
